import { css } from '@emotion/core';

import { breakpoints } from 'src/design-system/constants';
import { left } from 'src/design-system/mixins';
import { Theme } from 'src/design-system/theme';

const usageCardHeader = css`
  position: relative;
`;

const usageStatusIcon = (theme: Theme) => css`
  position: absolute;
  top: 4px;
  ${left('5px')(theme)}
`;

const tallCardBody = css`
  height: 250px;
`;

const memoryUsage = css`
  height: 250px;

  @media (min-width: ${breakpoints.md}px) {
    height: 125px;
  }
`;

const networkStats = css`
  @media (min-width: ${breakpoints.sm}px) {
    //height: 125px;
  }
`;

export const style = { usageStatusIcon, usageCardHeader, tallCardBody, memoryUsage, networkStats };
